module.exports = __webpack_public_path__ + "static/img/27.4d113bc9.png";